module.exports = __webpack_public_path__ + "img/nennnn.d577d754.jpg";